<div class="nft-lists-comp" [ngClass]="router.url.includes('/network-market/event') ? '':'mt-7'" [ngStyle]="{'background-color':settingsData?.event_bg_main_color}">

    <div class="filterheader" [ngClass]="router.url.includes('/network-market/event') ? '':'filter-background'" [ngStyle]="{'background-color':settingsData?.event_bg_main_color, 'color':settingsData?.event_font_main_color}">
        <h2>Find Your Perfect Event</h2>
        <p class="filterheader-subtitle">Browse live and upcoming events, then filter by group, team, sport or date.</p>
        <div class="btns text-center">
            <ng-container *ngFor="let cat of categoryList;let i=index">
                <button class="btn1 fs-14 mb-0" [ngStyle]="getButtonStyles(cat)"
                    (click)="catFilter(cat.name,i)"><a>{{cat.name}}</a></button>
            </ng-container>
        </div>
    </div>

    <section class="filter sticky p-20">
        <div class="filter-panel" [ngStyle]="{'background-color': settingsData?.event_bg_primary_color}" [style.--filter-accent]="settingsData?.event_font_primary_color" [style.--filter-bg]="settingsData?.event_bg_primary_color" [style.--filter-button-bg]="settingsData?.event_button_bg_primary_color" [style.--filter-button-font]="settingsData?.event_button_font_primary_color">
            <div class="filter-panel-header" [ngStyle]="{'border-bottom-color': settingsData?.event_font_primary_color}">
                <div class="filter-title" [ngStyle]="{'color': settingsData?.event_font_primary_color}">
                    <div class="s-con s-con--compact">
                        <input type="text" class="s-input" placeholder="Search by Event Name" (keyup.enter)="EventSearch()" [(ngModel)]="searchfil" [ngStyle]="{'background-color': settingsData?.event_bg_primary_color , 'color': settingsData?.event_font_primary_color, 'border-color': settingsData?.event_font_primary_color}"
                        [style]="'--placeholder-color:' + settingsData?.event_font_primary_color">
                        <i class="fa fa-search" [ngStyle]="{'color': settingsData?.event_font_primary_color}"></i>
                    </div>

                    <span class="filters-label">Filters:</span>

                    <div class="dropdown">
                        <button class="filter-chip filter-chip-control" type="button" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false" [ngStyle]="{'border-color': settingsData?.event_font_primary_color, 'color': settingsData?.event_font_primary_color}">
                            {{filterValue ? filterValue : 'Live & Upcoming'}}
                        </button>
                        <div class="dropdown-menu" [ngStyle]="{'background-color': settingsData?.event_bg_primary_color}" [style.--hover-bg]="settingsData?.event_button_bg_primary_color">
                            <span class="dropdown-itemm pointer" (click)="filterData('')" [style.color]="settingsData?.event_font_primary_color" [style.--hover-font]="settingsData?.event_button_font_primary_color">Live & Upcoming</span>
                            <ng-container *ngFor="let filter of FilterDrop">
                                <span class="dropdown-itemm pointer" (click)="filterData(filter)" [style.color]="settingsData?.event_font_primary_color" [style.--hover-font]="settingsData?.event_button_font_primary_color">{{filter}}</span>
                            </ng-container>
                        </div>
                    </div>

                    <ng-container *ngIf="selectedGroupName && !isGroupScoped">
                        <span class="filter-chip" [ngStyle]="{'border-color': settingsData?.event_font_primary_color, 'color': settingsData?.event_font_primary_color}">{{selectedGroupName}}<i class="fa fa-times" (click)="selectGroup(null)"></i></span>
                    </ng-container>
                    <ng-container *ngIf="selectedHomeTeamName">
                        <span class="filter-chip" [ngStyle]="{'border-color': settingsData?.event_font_primary_color, 'color': settingsData?.event_font_primary_color}">{{selectedHomeTeamName}}<i class="fa fa-times" (click)="selectHomeTeam(null)"></i></span>
                    </ng-container>
                    <ng-container *ngIf="selectedAwayTeamName">
                        <span class="filter-chip" [ngStyle]="{'border-color': settingsData?.event_font_primary_color, 'color': settingsData?.event_font_primary_color}">{{selectedAwayTeamName}}<i class="fa fa-times" (click)="selectAwayTeam(null)"></i></span>
                    </ng-container>
                    <ng-container *ngIf="selectedDivisionName">
                        <span class="filter-chip" [ngStyle]="{'border-color': settingsData?.event_font_primary_color, 'color': settingsData?.event_font_primary_color}">{{selectedDivisionName}}<i class="fa fa-times" (click)="selectDivision(null)"></i></span>
                    </ng-container>
                    <ng-container *ngIf="selectedSportName">
                        <span class="filter-chip" [ngStyle]="{'border-color': settingsData?.event_font_primary_color, 'color': settingsData?.event_font_primary_color}">{{selectedSportName}}<i class="fa fa-times" (click)="selectSport(null)"></i></span>
                    </ng-container>
                    <ng-container *ngIf="selectedDateRangeLabel">
                        <span class="filter-chip" [ngStyle]="{'border-color': settingsData?.event_font_primary_color, 'color': settingsData?.event_font_primary_color}">{{selectedDateRangeLabel}}</span>
                    </ng-container>
                </div>
                <div class="filter-header-actions">
                    <button type="button" class="filters-toggle-btn" (click)="showFilterPanel = !showFilterPanel" [ngStyle]="{'color': settingsData?.event_font_primary_color, 'border-color': settingsData?.event_font_primary_color}">
                        <i class="fa fa-filter"></i>
                        Filters
                        <span class="filters-badge" *ngIf="activeFilterCount" [ngStyle]="{'background-color': settingsData?.event_button_bg_primary_color, 'color': settingsData?.event_button_font_primary_color}">{{activeFilterCount}}</span>
                        <i class="fa" [ngClass]="showFilterPanel ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                    <button type="button" class="reset-btn" *ngIf="hasActiveFilters" (click)="resetAllFilters()" [ngStyle]="{'background-color': settingsData?.event_bg_secondary_color, 'color': settingsData?.event_font_secondary_color, 'border-color': settingsData?.event_font_secondary_color}" [style.--filter-secondary]="settingsData?.event_font_secondary_color">
                        <i class="fa fa-refresh"></i> Reset
                    </button>
                </div>
            </div>

            <ng-container *ngIf="showFilterPanel">
                <div class="filter-cards">
                    <div class="dropdown filter-card">
                        <button class="filter-card-btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" data-display="static" [ngStyle]="{'background-color': settingsData?.event_bg_primary_color , 'color': settingsData?.event_font_primary_color, 'border-color': settingsData?.event_font_primary_color}"
                            aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-sort filter-card-icon"></i>
                            <span class="filter-card-text">
                                <span class="filter-card-label">Sort By</span>
                                <span class="filter-card-value">{{sortValue ? sortValue : 'Event Date (Ascending)'}}</span>
                            </span>
                            <span class="fa fa-chevron-down filter-card-caret"></span>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" [ngStyle]="{'background-color': settingsData?.event_bg_primary_color}" [style.--hover-bg]="settingsData?.event_button_bg_primary_color">
                            <ng-container *ngFor="let sort of SortDrop">
                                <span class="dropdown-itemm pointer" (click)="sortData(sort)" [style.color]="settingsData?.event_font_primary_color" [style.--hover-font]="settingsData?.event_button_font_primary_color">{{sort.name}}</span>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Group filter -->
                    <app-filter-dropdown *ngIf="groupsList?.length && !isGroupScoped"
                        icon="fa-users" [label]="groupsLabel" [allLabel]="'All ' + groupsLabel + 's'"
                        [selectedLabel]="selectedGroupName"
                        [options]="groupsList | filter: groupSearchText:'name'"
                        [displayFn]="groupDisplayFn"
                        [searchable]="true" searchPlaceholder="Search group..."
                        [searchText]="groupSearchText" (searchTextChange)="groupSearchText = $event"
                        (optionSelect)="selectGroup($event)">
                    </app-filter-dropdown>

                    <!-- Home team filter -->
                    <app-filter-dropdown *ngIf="teamsList?.length"
                        icon="fa-shield" label="Home Team" allLabel="All Home Teams"
                        [selectedLabel]="selectedHomeTeamName"
                        [groupedOptions]="homeGroupGroups"
                        [displayFn]="teamDisplayFn"
                        [searchable]="true" searchPlaceholder="Search team..."
                        [searchText]="homeTeamSearchText" (searchTextChange)="onHomeTeamSearchTextChange($event)"
                        (optionSelect)="selectHomeTeam($event)">
                    </app-filter-dropdown>

                    <!-- Away team filter -->
                    <app-filter-dropdown *ngIf="teamsList?.length"
                        icon="fa-shield" label="Away Team" allLabel="All Away Teams"
                        [selectedLabel]="selectedAwayTeamName"
                        [groupedOptions]="awayGroupGroups"
                        [displayFn]="teamDisplayFn"
                        [searchable]="true" searchPlaceholder="Search team..."
                        [searchText]="awayTeamSearchText" (searchTextChange)="onAwayTeamSearchTextChange($event)"
                        (optionSelect)="selectAwayTeam($event)">
                    </app-filter-dropdown>

                    <!-- Division filter -->
                    <app-filter-dropdown *ngIf="divisionOptions?.length"
                        icon="fa-sitemap" label="Division" allLabel="All Divisions"
                        [selectedLabel]="selectedDivisionName"
                        [options]="divisionOptions"
                        [displayFn]="divisionDisplayFn"
                        (optionSelect)="selectDivision($event)">
                    </app-filter-dropdown>

                    <!-- Sport filter -->
                    <app-filter-dropdown *ngIf="sportOptions?.length"
                        icon="fa-futbol-o" label="Sport" allLabel="All Sports"
                        [selectedLabel]="selectedSportName"
                        [options]="sportOptions"
                        [displayFn]="sportDisplayFn"
                        (optionSelect)="selectSport($event)">
                    </app-filter-dropdown>

                    <!-- Date range filter -->
                    <div class="date-range-filter">
                        <div class="date-filter-container">
                            <div class="date-range-picker-wrap">
                                <div class="date-range-display">
                                    <span>{{dateRangeDisplayStart}}</span>
                                    <span class="date-range-display-sep">&ndash;</span>
                                    <span>{{dateRangeDisplayEnd}}</span>
                                </div>
                                <mat-form-field appearance="fill" subscriptSizing="dynamic" class="date-range-picker-field-hidden">
                                    <mat-date-range-input [rangePicker]="picker" [min]="dateRangeMinDate" [max]="dateRangeMaxDate">
                                        <input matStartDate [value]="dateRangePickerStart" readonly placeholder="Start"
                                            (dateChange)="onDateRangeStartChange($event.value)">
                                        <input matEndDate [value]="dateRangePickerEnd" readonly placeholder="End"
                                            (dateChange)="onDateRangeEndChange($event.value)">
                                    </mat-date-range-input>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>
                            </div>
                            <i class="fa fa-calendar date-range-calendar-icon" (click)="picker.open()"></i>
                            <div class="vertical-line vertical-line-spacer"></div>
                            <ng-container *ngFor="let preset of dateRangePresets; let last = last">
                                <div class="date-filter-button" [class.active-date-filter]="isDateRangeActive(preset)"
                                    (click)="selectDateRangePreset(preset)">{{ preset.label }}</div>
                                <div class="vertical-line" *ngIf="!last"></div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </section>
    <ng-container *ngIf="isLoadingEvent && bannerList.length == 0">
        <div class="text-center fs-22 text-light" [ngClass]="{'dynamic-text': settingsData?.event_font_main_color}" [ngStyle]="{'--dynamic-text-color': settingsData?.event_font_main_color}"><i class="fa fa-spinner fa-spin mr-2"></i> Processing data...</div>
    </ng-container>
    <ng-container *ngIf="!isLoadingEvent && eventsLoadError">
        <div class="text-center fs-22 text-light" [ngClass]="{'dynamic-text': settingsData?.event_font_main_color}" [ngStyle]="{'--dynamic-text-color': settingsData?.event_font_main_color}">
            Unable to load events right now.
            <div class="mt-15">
                <button mat-flat-button class="flat-primary-button" [ngClass]="{
                    'dynamic-bg': settingsData?.event_button_bg_primary_color,
                    'dynamic-text': settingsData?.event_button_font_primary_color
                }" [ngStyle]="{
                    '--dynamic-bg-color': settingsData?.event_button_bg_primary_color,
                    '--dynamic-text-color': settingsData?.event_button_font_primary_color
                }" (click)="retryEvents()">Try Again</button>
            </div>
        </div>
    </ng-container>
    <!-- Computed once via *ngIf's `as` alias (an array is always truthy, even empty) so the
         "no results" check and the *ngFor below read the exact same search-filtered list -
         checking bannerList.length here missed the case where the date/category filters found
         events but the event-name search matched none of them, showing a blank area instead of
         a "no results" message. -->
    <ng-container *ngIf="(bannerList | filter: searchfil:'stream_video_title') as filteredBannerList">
        <ng-container *ngIf="!isLoadingEvent && !eventsLoadError && filteredBannerList.length == 0">
            <div class="text-center fs-22 text-light" [ngClass]="{'dynamic-text': settingsData?.event_font_main_color}" [ngStyle]="{'--dynamic-text-color': settingsData?.event_font_main_color}">No Events Available</div>
        </ng-container>
        <section class="card-Sec">
            <div class="cards-con">
                <ng-container *ngFor="let item of filteredBannerList; let i = index">
                    <div class="cards pointer" [ngStyle]="{'background-color':settingsData?.event_card_bg_color}">
                    <!-- <div class="imagediv" *ngIf="item.isEvent == 'upcoming'"
                        [ngStyle]="{'background-image': item.event_home_bannerr ? 'url(' + item.event_home_banner + ')' : 'url(' + item.video_banner_image + ')'}">
                    </div> -->
                    <div class="imagediv"
                        [ngStyle]="{'background-image': item.event_home_bannerr ? 'url(' + item.event_home_banner + ')' : 'url(' + item.video_banner_image + ')'}">
                    </div>
                    <div class="desc-con ">
                        <div class="desc-h mb-2" matTooltipPosition="above" matTooltip="{{item?.stream_video_title}}" [ngStyle]="{'color':settingsData?.event_card_font_color}">
                            {{item.stream_video_title}}</div>
                        <div class="desc dayellips" [ngStyle]="{'color':settingsData?.event_card_font_color}"
                            *ngIf="item.selected_type != 'multi_day_event' && item?.selected_type != 'recurring_event'"
                            matTooltipPosition="above" matTooltip="{{item.org_publish_date_time}}">
                            {{item.org_publish_date_time}}</div>
                        <div class="desc dayellips" [ngStyle]="{'color':settingsData?.event_card_font_color}"
                            *ngIf="item.selected_type == 'multi_day_event' || item?.selected_type == 'recurring_event'"
                            matTooltipPosition="above"
                            matTooltip=" {{item.org_publish_date_time }} - {{item.org_expected_end_date_time}}">
                            {{item.org_publish_date_time }} - {{item.org_expected_end_date_time}}

                        </div>
                        <div>
                        </div>
                        <button mat-flat-button class="mt-15 mbr-50 flat-primary-button card-carousel-view-btn" [ngStyle]="{'background-color':settingsData?.event_button_bg_primary_color, 'color':settingsData?.event_button_font_primary_color}"
                            (click)="goToEventReg(item)">View Details</button>

                    </div>
                </div>
                </ng-container>
            </div>
        </section>
    </ng-container>

</div>